const NavLinks = () => {
  const links = document.querySelectorAll('.site-navigation a')  
  links.forEach(link => {        
    const url = new URL(link.href);
    if(url.hostname !== location.hostname) 
      link.target = '_blank';
  })
}

document.addEventListener('DOMContentLoaded', () => {
  NavLinks()
})